import React, { useState } from 'react';
import { handoverTask } from "../Services/masterService";
import Modal from '../AlertModal/Modal';

const HandoverTaskModal = ({ isOpen, onClose, taskData, operationUsers = [], onSubmit }) => {
    // State to manage the selected operations user ID from the dropdown
    const [selectedOpUserId, setSelectedOpUserId] = useState('');
    // State to manage the loading/submitting status
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalConfig, setModalConfig] = useState({});

    const showSuccess = (msg) => {
        setModalConfig({
            title: "Success!",
            message: msg,
            type: "success",
        });
        setIsModalOpen(true);
    };

    const showError = (titleMsg, message) => {
        setModalConfig({
            title: titleMsg,
            message: message,
            type: "error",
        });
        setIsModalOpen(true);
    };

    // Handler for the form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedOpUserId) {
            showError('Oops!', 'Please select an operations user to hand over the task.');
            return;
        }

        setIsSubmitting(true);
        const payload = {
            taskId: taskData.id,
            logisticUserId: taskData.assignedTo,
            operationUserId: parseInt(selectedOpUserId, 10),
        };

        try {
            const result = await handoverTask(payload);
            console.log('dfkjhsdfhksdfh', result)
            if (result.status == 1) {
                showSuccess("Handover Successfully!");
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                showError("Failed to handovered!")
            }
        } catch (error) {
            showError("Sorry!", "Submission failed: " + error);
            // In a real app, you might show an error message to the user here.
        } finally {
            setIsSubmitting(false); // Reset submitting state regardless of success or failure
        }
    };

    if (!isOpen) {
        return null; // Don't render anything if the modal is not open
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md transform transition-all">
                <div className="bg-gradient-to-r from-emerald-600 to-green-600 p-5 flex justify-between items-center rounded-t-xl">
                    <h2 className="text-xl font-bold text-white">Handover Task</h2>
                    <button onClick={onClose} disabled={isSubmitting} className="text-white hover:text-green-200 text-2xl">&times;</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="p-6 space-y-4">
                        <p className="text-sm text-gray-600">
                            You are about to hand over Task ID: <span className="font-bold text-gray-800">{taskData.id}</span>.
                        </p>

                        <div>
                            <label htmlFor="operationUser" className="block text-sm font-medium text-gray-700 mb-1">Select Operations User</label>
                            <select
                                id="operationUser"
                                value={selectedOpUserId}
                                onChange={(e) => setSelectedOpUserId(e.target.value)}
                                className="w-full p-3 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-emerald-500 focus:outline-none"
                                required
                            >
                                <option value="">-- Choose a user --</option>
                                {operationUsers.map(user => (
                                    <option key={user.id} value={user.id}>{user.employeeName}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="bg-gray-50 p-4 flex justify-end space-x-4 rounded-b-xl">
                        <button
                            type="button"
                            onClick={onClose}
                            disabled={isSubmitting}
                            className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg font-semibold hover:bg-gray-300 transition-colors disabled:opacity-50"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={isSubmitting || !selectedOpUserId}
                            className="px-6 py-2 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors disabled:bg-green-300 disabled:cursor-not-allowed"
                        >
                            {isSubmitting ? 'Submitting...' : 'Submit Handover'}
                        </button>
                    </div>
                </form>
            </div>

            <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                title={modalConfig.title}
                message={modalConfig.message}
                type={modalConfig.type}
            />
        </div>
    );
};

export default HandoverTaskModal;
